module.exports = __webpack_public_path__ + "img/background_bad.b77a6fcd.png";